module.exports = __webpack_public_path__ + "static/media/dispatchedLetter.917cf502.svg";